/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateEventInvitationV2Dto } from '../models/work-create-event-invitation-v-2-dto';
import { WorkEventInvitation } from '../models/work-event-invitation';
import { WorkNotInvitedFromAudienceDto } from '../models/work-not-invited-from-audience-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSendInvitationLinkDto } from '../models/work-send-invitation-link-dto';
import { WorkUpdateEventInvitationV2Dto } from '../models/work-update-event-invitation-v-2-dto';

@Injectable({ providedIn: 'root' })
export class WorkEventInvitationsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventInvitationsV2ControllerFindAllPaginated()` */
  static readonly EventInvitationsV2ControllerFindAllPaginatedPath = '/v2/event-invitations';

  /**
   * Required permissions: events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by acceptedAt query param.
     *           <p>
     *              <b>Format: </b> filter.acceptedAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.acceptedAt=$not:$like:John Doe&filter.acceptedAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.acceptedAt'?: Array<string>;

    /**
     * Filter by declinedAt query param.
     *           <p>
     *              <b>Format: </b> filter.declinedAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.declinedAt=$not:$like:John Doe&filter.declinedAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.declinedAt'?: Array<string>;

    /**
     * Filter by eventId query param.
     *           <p>
     *              <b>Format: </b> filter.eventId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.eventId=$not:$like:John Doe&filter.eventId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.eventId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> user.firstName:ASC,contact.firstName:ASC,email:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>user.firstName</li>
     * <li>contact.firstName</li>
     * <li>acceptedAt</li>
     * <li>declinedAt</li></ul>
     */
      sortBy?: Array<'user.firstName:ASC' | 'user.firstName:DESC' | 'contact.firstName:ASC' | 'contact.firstName:DESC' | 'acceptedAt:ASC' | 'acceptedAt:DESC' | 'declinedAt:ASC' | 'declinedAt:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> user.firstName,user.lastName,contact.firstName,contact.lastName,firstName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>user.firstName</li>
     * <li>user.lastName</li>
     * <li>contact.firstName</li>
     * <li>contact.lastName</li>
     * <li>firstName</li>
     * <li>lastName</li>
     * <li>email</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEventInvitation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'acceptedAt'?: (string | Array<string>);
'declinedAt'?: (string | Array<string>);
'eventId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsV2Service.EventInvitationsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.acceptedAt', params['filter.acceptedAt'], {});
      rb.query('filter.declinedAt', params['filter.declinedAt'], {});
      rb.query('filter.eventId', params['filter.eventId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkEventInvitation>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'acceptedAt'?: (string | Array<string>);
        'declinedAt'?: (string | Array<string>);
        'eventId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by acceptedAt query param.
     *           <p>
     *              <b>Format: </b> filter.acceptedAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.acceptedAt=$not:$like:John Doe&filter.acceptedAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.acceptedAt'?: Array<string>;

    /**
     * Filter by declinedAt query param.
     *           <p>
     *              <b>Format: </b> filter.declinedAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.declinedAt=$not:$like:John Doe&filter.declinedAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.declinedAt'?: Array<string>;

    /**
     * Filter by eventId query param.
     *           <p>
     *              <b>Format: </b> filter.eventId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.eventId=$not:$like:John Doe&filter.eventId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.eventId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> user.firstName:ASC,contact.firstName:ASC,email:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>user.firstName</li>
     * <li>contact.firstName</li>
     * <li>acceptedAt</li>
     * <li>declinedAt</li></ul>
     */
      sortBy?: Array<'user.firstName:ASC' | 'user.firstName:DESC' | 'contact.firstName:ASC' | 'contact.firstName:DESC' | 'acceptedAt:ASC' | 'acceptedAt:DESC' | 'declinedAt:ASC' | 'declinedAt:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> user.firstName,user.lastName,contact.firstName,contact.lastName,firstName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>user.firstName</li>
     * <li>user.lastName</li>
     * <li>contact.firstName</li>
     * <li>contact.lastName</li>
     * <li>firstName</li>
     * <li>lastName</li>
     * <li>email</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkEventInvitation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'acceptedAt'?: (string | Array<string>);
'declinedAt'?: (string | Array<string>);
'eventId'?: (string | Array<string>);
};
};
}> {
    return this.eventInvitationsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkEventInvitation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'acceptedAt'?: (string | Array<string>);
'declinedAt'?: (string | Array<string>);
'eventId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkEventInvitation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'acceptedAt'?: (string | Array<string>);
'declinedAt'?: (string | Array<string>);
'eventId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV2ControllerCreate()` */
  static readonly EventInvitationsV2ControllerCreatePath = '/v2/event-invitations';

  /**
   * Required permissions: events:admin, events:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV2ControllerCreate$Response(
    params: {
      body: WorkCreateEventInvitationV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsV2Service.EventInvitationsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV2ControllerCreate(
    params: {
      body: WorkCreateEventInvitationV2Dto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.eventInvitationsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV2ControllerFindOneById()` */
  static readonly EventInvitationsV2ControllerFindOneByIdPath = '/v2/event-invitations/{id}';

  /**
   * Required permissions: events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventInvitation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsV2Service.EventInvitationsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventInvitation>;
      })
    );
  }

  /**
   * Required permissions: events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkEventInvitation> {
    return this.eventInvitationsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventInvitation>): WorkEventInvitation => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV2ControllerUpdate()` */
  static readonly EventInvitationsV2ControllerUpdatePath = '/v2/event-invitations/{id}';

  /**
   * Required permissions: events:admin, events:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateEventInvitationV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventInvitation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsV2Service.EventInvitationsV2ControllerUpdatePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventInvitation>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateEventInvitationV2Dto
    },
    context?: HttpContext
  ): Observable<WorkEventInvitation> {
    return this.eventInvitationsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventInvitation>): WorkEventInvitation => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV2ControllerDelete()` */
  static readonly EventInvitationsV2ControllerDeletePath = '/v2/event-invitations/{id}';

  /**
   * Required permissions: events:admin, events:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsV2Service.EventInvitationsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventInvitationsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV2ControllerFindByContactId()` */
  static readonly EventInvitationsV2ControllerFindByContactIdPath = '/v2/event-invitations/byContact/{contactId}';

  /**
   * Required permissions: events:admin, events:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV2ControllerFindByContactId()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerFindByContactId$Response(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkEventInvitation>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsV2Service.EventInvitationsV2ControllerFindByContactIdPath, 'get');
    if (params) {
      rb.path('contactId', params.contactId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkEventInvitation>>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV2ControllerFindByContactId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerFindByContactId(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkEventInvitation>> {
    return this.eventInvitationsV2ControllerFindByContactId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkEventInvitation>>): Array<WorkEventInvitation> => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV2ControllerSendInvitationLink()` */
  static readonly EventInvitationsV2ControllerSendInvitationLinkPath = '/v2/event-invitations/sendInvitationLink';

  /**
   * Required permissions: events:admin, events:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV2ControllerSendInvitationLink()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV2ControllerSendInvitationLink$Response(
    params: {
      body: WorkSendInvitationLinkDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsV2Service.EventInvitationsV2ControllerSendInvitationLinkPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV2ControllerSendInvitationLink$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventInvitationsV2ControllerSendInvitationLink(
    params: {
      body: WorkSendInvitationLinkDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.eventInvitationsV2ControllerSendInvitationLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV2ControllerFindMyInvitationByEventId()` */
  static readonly EventInvitationsV2ControllerFindMyInvitationByEventIdPath = '/v2/event-invitations/myInvitationByEventId/{eventId}';

  /**
   * Required permissions: events:admin, events:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV2ControllerFindMyInvitationByEventId()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerFindMyInvitationByEventId$Response(
    params: {
      eventId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventInvitation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsV2Service.EventInvitationsV2ControllerFindMyInvitationByEventIdPath, 'get');
    if (params) {
      rb.path('eventId', params.eventId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventInvitation>;
      })
    );
  }

  /**
   * Required permissions: events:admin, events:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV2ControllerFindMyInvitationByEventId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerFindMyInvitationByEventId(
    params: {
      eventId: number;
    },
    context?: HttpContext
  ): Observable<WorkEventInvitation> {
    return this.eventInvitationsV2ControllerFindMyInvitationByEventId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventInvitation>): WorkEventInvitation => r.body)
    );
  }

  /** Path part for operation `eventInvitationsV2ControllerFindNotInvitedFromAudiences()` */
  static readonly EventInvitationsV2ControllerFindNotInvitedFromAudiencesPath = '/v2/event-invitations/{eventId}/not-invited-from-audiences';

  /**
   * Required permissions: events:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventInvitationsV2ControllerFindNotInvitedFromAudiences()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerFindNotInvitedFromAudiences$Response(
    params: {
      eventId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNotInvitedFromAudienceDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkEventInvitationsV2Service.EventInvitationsV2ControllerFindNotInvitedFromAudiencesPath, 'get');
    if (params) {
      rb.path('eventId', params.eventId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNotInvitedFromAudienceDto>;
      })
    );
  }

  /**
   * Required permissions: events:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventInvitationsV2ControllerFindNotInvitedFromAudiences$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventInvitationsV2ControllerFindNotInvitedFromAudiences(
    params: {
      eventId: number;
    },
    context?: HttpContext
  ): Observable<WorkNotInvitedFromAudienceDto> {
    return this.eventInvitationsV2ControllerFindNotInvitedFromAudiences$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNotInvitedFromAudienceDto>): WorkNotInvitedFromAudienceDto => r.body)
    );
  }

}
